const translations = {
  fr: {
    commonAuthentication: {
      emailEmptyMessage: 'Veuiller saisir votre adresse courriel',
      emailInvalidMessage: 'Le format du courriel fourni n\'est pas valide',
      passwordEmptyMessage: 'Veuillez saisir votre mot de passe',
      passwordInvalidMessage: 'Votre mot de passe doit contenir au moins 8 caractères et une majuscule et/ou un chiffre et/ou un caractère special',
      passwordNotSimilarMessage: 'Ce mot de passe ne correspond pas au mot de passe fourni',
      email: 'Courriel',
      password: 'Mot de passe',
      emailOrPasswordInvalid: 'Le courriel ou le mot de passe est invalide',
      login: 'Connexion',
      forgotPasswordQuestion: 'Mot de passe oublié?',
      provideYourEmail: 'Entrez votre courriel',
      send: 'Envoyer',
      forgotPassword: 'Mot de passe oublié',
      forgotPasswordSent: 'Si le compte existe, un courriel de récupération de mot de passe aura été envoyé au compte',
      forgotPasswordError: 'Une erreur est survenue, veuillez réessayer ou nous contacter.',
      passwordChange: 'Changement de mot de passe',
      passwordVerification: 'Vérification du mot de passe',
      change: 'Changer',
      passwordChangeSuccess: 'Votre mot de passe a été changé avec succès',
      passwordChangeError: 'Une erreur est survenue lors du changement de mot de passe.',
      passwordChangeErrorContact: 'Veuillez réessayer ou contacter un administrateur.',
      forgotPasswordReturn: 'Retour',
    },
  },
  en: {
    commonAuthentication: {
      emailEmptyMessage: 'Please enter your email address',
      emailInvalidMessage: 'The format of the email is not valid',
      passwordEmptyMessage: 'Please enter your password',
      passwordInvalidMessage: 'Your password must contain at least 8 characters and an uppercase and / or a number and / or a special character',
      passwordNotSimilarMessage: 'This password does not match the provided password',
      email: 'Email',
      password: 'Password',
      emailOrPasswordInvalid: 'Email or password is invalid',
      login: 'Log in',
      forgotPasswordQuestion: 'Forgot password?',
      provideYourEmail: 'Please provide your email',
      send: 'Send',
      forgotPassword: 'Forgot password',
      forgotPasswordSent: 'If the account exists, a password recovery email will have been sent to the account',
      forgotPasswordError: 'An error occured, please try again or contact us.',
      passwordChange: 'Password change',
      passwordVerification: 'Verify the password',
      change: 'Change',
      passwordChangeSuccess: 'Your password has been successfully changed',
      passwordChangeError: 'Error while changing password',
      passwordChangeErrorContact: 'Please try again or contact an administrator.',
      forgotPasswordReturn: 'Back',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/common/modules/authentication/i18n/commonAuthentication.js